import React from "react";

export default function Footer() {
  return (
    <footer className="bg-[#0099CC] text-white py-24">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 mb-16">
          <div>
            <img
              alt="Editora LT Logo"
              className="h-28 mb-6 object-contain"
              src="https://storage.readdy-site.link/project_files/c04e2fd4-d20c-4f0f-90a5-97e79a0275c8/9347c2c7-f601-49e0-bd2f-eaae6110b37e_WhatsApp-Image-2026-02-03-at-19.30.34.jpeg?v=935549c4685cfbdc717cd1fad2cda3af"
            />
            <p className="text-white/80 text-sm">
              Transformando a educação brasileira através de cursos de qualidade e
              inovação pedagógica.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Cursos</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Educação Infantil
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Arte e Educação
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Desenvolvimento Juvenil
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Todos os Cursos
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Sobre</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Quem Somos
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Nossa Missão
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Certificações
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-white/80 hover:text-[#FFCC00] transition-colors cursor-pointer"
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Redes Sociais</h3>
            <div className="flex gap-3 mb-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center bg-white/20 hover:bg-[#FFCC00] rounded-lg transition-all hover:scale-110 cursor-pointer"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
            <p className="text-white/80 text-sm">
              Siga-nos nas redes sociais para novidades e conteúdos exclusivos
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/70">
            <p>© 2025 Editora LT - Todos os direitos reservados</p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="hover:text-[#FFCC00] transition-colors cursor-pointer"
              >
                Política de Privacidade
              </a>
              <a
                href="#"
                className="hover:text-[#FFCC00] transition-colors cursor-pointer"
              >
                Termos de Uso
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#FFCC00] transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
